import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const siteUrl = 'https://szkolazlotnictwa.pl';

// Ustawia <link rel="canonical"> na główny adres bieżącej podstrony
function Canonical() {
  const { pathname } = useLocation();
  useEffect(() => {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/';
    link.href = `${siteUrl}${path}`;
  }, [pathname]);
  return null;
}

export default Canonical;
